<template>
    <div class="text-center my-6">
        <v-dialog v-model="dialog" max-width="800">
            <template v-slot:activator="{ on, attrs }">
                <v-btn class="text-caption text-sm-body2" width="300px" color="rounded-0" light v-bind="attrs" v-on="on">
                    {{$t("LP.spec.title")}}
                </v-btn>
            </template>

            <v-card light style="background: #fff;">
                <!-- 閉じるボタン -->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="black" icon @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-actions>

                <v-container class="pa-5 pa-sm-6 px-lg-15">
                    <!-- ダイアログタイトル -->
                    <v-card-title class="headline justify-center">
                        {{$t("LP.spec.title")}}
                    </v-card-title>
                    <v-card-text class="mt-6">
                        <h4>{{$t('LP.spec.browser.title')}}</h4>
                        <p v-text="$t('LP.spec.browser.text')" class="text-pre-wrap mt-1" style="text-indent: -0.5em;"></p>
                        <h4 class="mt-6">{{$t('LP.spec.function.title')}}</h4>
                        <p v-text="$t('LP.spec.function.text')" class="text-pre-wrap mt-1"></p>
                    </v-card-text>
                </v-container>

                


            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {

        computed: {
            binding() {
                const binding = {}

                if (this.$vuetify.breakpoint.xsOnly) binding.row = true

                return binding
            }
        },

        data() {
            return {
                dialog: false,
                notifications: false,
                sound: true,
                widgets: false,
            }
        },
    }
</script>